import store from './../store'
// 封装请求
import {
	POST,
	GET,
	SEALP,
	SEALPS,
	SEALG
} from './http';

//获取个人信息
export function getUserInfo() {
	return new Promise((resolve, reject) => {
		POST("/my/api/getDetailForMobile")
			.then((res) => {
				resolve(res);
				if (res.success && res.data) {
					store.dispatch("actionUserInfo", res.data);
				}
			}).catch(err => {
				reject(err)
			});
	})
}

//获取消息列表
export function getBanner() {
	return new Promise((resolve, reject) => {
		POST("/my/api/getBanner")
			.then((res) => {
				resolve(res);
				if (res.success && res.data && res.data.messages) {
					store.dispatch('actionMessageCount', res.data.messages.length)
				} else {
					store.dispatch('actionMessageCount', 0)
				}
			}).catch(err => {
				console.log('getBanner',err)
				reject(err)
				store.dispatch('actionMessageCount', 0)
			});
	})
}